jQuery($ => {
    class Navigation {
      constructor(element) {
        this._        = element;
        this._element = $(element);
        this._link    = this._element.find('.m-navigation__link');
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._link.on('keydown', this.handleKeydown);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleKeydown = (event) => {
        const index = this._link.index(event.currentTarget);

        switch (event.key) {
          case 'ArrowLeft':
            event.preventDefault();
            
            const prevIndex = index - 1;

            if (prevIndex >= 0) {
              this._link.eq(prevIndex).focus();
            } else {
              this._link.last().focus();
            }

            break;

          case 'ArrowRight':
            event.preventDefault();

            const nextIndex = index + 1;

            if (nextIndex <= this._link.length - 1) {
              this._link.eq(nextIndex).focus();
            } else {
              this._link.first().focus();
            }

            break;
        }
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.navigation = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].navigation = new Navigation(_[i], opt);
        else
          ret = _[i].navigation[opt].apply(_[i].navigation, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.m-navigation').navigation();
});